function tp_testimonial() {
  const tp_testimonial = document.querySelector('.tp-testimonial__inner');
  if(!tp_testimonial) return;
  const slidesPerView = Number(tp_testimonial.dataset.desktop);
  const spaceBetween = 0;
  const loop = tp_testimonial.dataset.loop === "true";
  const autoplay = tp_testimonial.dataset.autoplay === "true";

  var swiper_testimonial = new Swiper('.tp-testimonial__inner', {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    loop: loop,
    autoplay: autoplay,
    grabCursor: true,
    effect: "creative",
    preventClicksPropagation: true,
    creativeEffect: {
      prev: {
        shadow: true,
        translate: [0, 0, -400],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    navigation: {
      nextEl: ".swiper-next-testimonial",
      prevEl: ".swiper-prev-testimonial",
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-testimonial",
    },
  });
}
tp_testimonial();
document.addEventListener("shopify:section:load", tp_testimonial);
document.addEventListener("shopify:section:unload", tp_testimonial);